<mat-form-field
  appearance="outline"
  class="sg-input-field sg-ui-component"
  [subscriptSizing]="subscriptSizing"
  [class.sg-variant-primary]="variant === 'primary'"
  [class.sg-variant-secondary]="variant === 'secondary'"
  [class.sg-size-small]="size === 'small'"
  [class.sg-size-default]="size === 'default'"
  [class.has-prefix]="shouldShowPrefix"
  [class.has-value]="internalFormControl.value?.length > 0"
  [class.has-placeholder]="!!placeholder"
  [class.show-clear-button]="showClearButton"
  [class.show-password-toggle]="showPasswordSuffix"
  [class.show-submit-button]="showSubmitButton"
  [class.no-label]="!label || hideLabel">
  <!-- Label -->
  @if (!hideLabel) {
  <mat-label>{{label}}</mat-label>
  }
  <!-- Prefix -->
  @if (prefix) {
  <span matPrefix class="sg-input-prefix-text">{{prefix}}</span>
  } @if (prefixIcon && !prefix) {
  <mat-icon matPrefix class="sg-input-prefix-icon">{{prefixIcon}}</mat-icon>
  }
  <!-- Input Field -->
  <input
    matInput
    [type]="currentInputType"
    [formControl]="internalFormControl"
    [placeholder]="effectivePlaceholder"
    [step]="numberStep"
    [min]="min"
    [max]="max"
    [required]="isRequired"
    (blur)="onInputBlur()"
    (focus)="onInputFocus()" />
  <!-- Right Actions / Suffix -->
  <ng-container matSuffix>
    <!-- Submit Button (highest priority) -->
    @if (showSubmitButton) {
    <sg-button
      (onClick)="onSubmit()"
      [disabled]="this.internalFormControl.invalid"
      [isLoading]="submitButtonIsLoading$ | async"
      [icon]="submitButtonIcon"
      [text]="null"
      size="small"
      variant="ghost-secondary"
      class="submit-button-icon sg-ui-component"
      [class.sg-loading-btn]="submitButtonIsLoading$ | async"></sg-button>
    }
    <!-- Password Toggle (second priority) -->
    @if (showPasswordSuffix) {
    <button mat-icon-button type="button" class="sg-input-password-toggle sg-ui-component" (click)="togglePasswordVisibility()">
      <mat-icon>{{passwordIcon}}</mat-icon>
    </button>
    }
    <!-- Clear Button (third priority) -->
    @if (showClearButton) {
    <button mat-icon-button type="button" class="sg-input-clear-button sg-ui-component" (click)="clearInput()">
      <mat-icon>close</mat-icon>
    </button>
    }
    <!-- Text Suffix (only if no right actions) -->
    @if (shouldShowSuffix) {
    <span class="sg-input-suffix-text">{{suffix}}</span>
    }
  </ng-container>
  <!-- Hint -->
  @if (hint) {
  <mat-hint align="start" class="sg-input-hint sg-ui-component">{{hint}}</mat-hint>
  }
  <!-- Character Counter -->
  @if (maxLimit) {
  <mat-hint align="end" class="sg-input-character-counter sg-ui-component">{{valueLength}} / {{maxLimit}}</mat-hint>
  }
  <!-- Error Messages -->
  @if (hasErrors) {
  <mat-error class="sg-input-error sg-ui-component">{{getErrorMessage()}}</mat-error>
  }
  <!-- From master -->
  <!--<mat-error *ngIf="hasErrors && !hideError" class="sg-padding-top-20"> <ng-container *ngIf="internalFormControl?.errors?.required"> <sg-text variant="sg-body-xsmall-regular">Required</sg-text> </ng-container> <ng-container *ngIf="!internalFormControl?.errors?.required"> <! -- TODO - ask Subin if we should show both errors together -- > <sg-text variant="sg-body-xsmall-regular" *ngFor="let errorName of errorsEntries">{{errorsMap[errorName]}}</sg-text> </ng-container> </mat-error> -->
</mat-form-field>
